import React from 'react';
import { stats } from '../mock';

const Stats = () => {
  return (
    <section className="relative py-16 border-y border-white/[0.06] bg-gradient-to-b from-black to-[#0a0a0a]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((s, i) => (
            <div key={s.label} className="text-center md:text-left group">
              <div className="text-4xl md:text-5xl font-bold gold-gradient-text mb-2 tracking-tight">
                {s.value}
              </div>
              <div className="text-neutral-400 text-sm md:text-base font-medium tracking-wide">
                {s.label}
              </div>
              {i < stats.length - 1 && (
                <div className="hidden md:block" />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
